import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { LockKeyhole } from "lucide-react";
import { toast } from "sonner";

function formatError(detail) {
  if (detail == null) return "Login failed";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e=>e?.msg||JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user && user !== false) return <Navigate to="/admin" replace/>;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-sky-100 px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-3xl shadow-medium p-10" data-testid="admin-login-form">
        <div className="h-14 w-14 rounded-2xl bg-primary/8 text-primary flex items-center justify-center"><LockKeyhole className="w-7 h-7"/></div>
        <h1 className="font-heading text-3xl font-medium mt-6">Admin Login</h1>
        <p className="text-sm text-slate-500 mt-2">Sign in to manage the website.</p>
        <div className="mt-7 space-y-4">
          <div><Label>Email</Label><Input type="email" required value={email} onChange={e=>setEmail(e.target.value)} className="mt-2" data-testid="admin-email"/></div>
          <div><Label>Password</Label><Input type="password" required value={password} onChange={e=>setPassword(e.target.value)} className="mt-2" data-testid="admin-password"/></div>
        </div>
        <Button type="submit" disabled={loading} className="w-full mt-7 rounded-full bg-primary hover:bg-primary-dark py-6" data-testid="admin-login-btn">{loading?"Signing in…":"Sign In"}</Button>
      </form>
    </main>
  );
}
